export enum WebsocketTopic {
  GLOBAL = 'global',
  APPLICATION_VERSION_UPDATE = 'applicationVersionUpdate'
}
